import { TASK_DURATIONS } from '@goaltree/backend/convex/lib/timeBudget'
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from '@goaltree/ui/components/popover'
import { cn } from '@goaltree/ui/lib/utils'
import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { formatMinutes } from '@/lib/task-time'

// How long a task takes (the plan's estimate), for tasks without a timed slot.
export function TaskDurationPicker({
  value,
  onChange,
  className,
}: {
  value?: number
  onChange: (minutes: number) => void
  className?: string
}) {
  const { t } = useTranslation()
  return (
    <Popover>
      <PopoverTrigger className={cn(className, !value && 'text-muted-foreground')}>
        {value ? (
          formatMinutes(value)
        ) : (
          <>
            {t('timeBudget.addTime')}
            <Plus className="h-3 w-3" />
          </>
        )}
      </PopoverTrigger>
      <PopoverContent
        className="flex w-auto max-w-[15rem] flex-wrap gap-1 p-2"
        side="bottom"
        align="start"
      >
        {TASK_DURATIONS.map((m) => (
          <PopoverClose
            key={m}
            onClick={() => onChange(m)}
            className={cn(
              'cursor-pointer rounded-md px-2 py-1 text-xs font-medium tabular-nums transition-colors hover:bg-muted',
              value === m
                ? 'bg-primary text-primary-foreground hover:bg-primary'
                : 'text-foreground',
            )}
          >
            {formatMinutes(m)}
          </PopoverClose>
        ))}
      </PopoverContent>
    </Popover>
  )
}
